import {
	getCloudId,
	getHelpCenterAri,
	getWorkspaceAri,
	getLayoutAri,
	getMeta,
} from '@helpcenter/meta';
import { getRelayEnvironment } from '@atlassian/help-center-common-util/relay';
import type { Environment } from 'react-relay';
import type { ResourceStoreContext } from 'react-resource-router/resources';
import { createResourcesPlugin } from 'react-resource-router/resources';
import { PROJECT_NAME } from 'routes/common/constants';

const customContext: ResourceStoreContext & { relayEnvironment?: Environment } = {
	cloudId: getCloudId(),
	productName: PROJECT_NAME,
	helpCenterAri: getHelpCenterAri(),
	workspaceAri: getWorkspaceAri(),
	layoutAri: getLayoutAri(),
	isUserLoggedIn: Boolean(getMeta('ajs-atlassian-account-id')),
	accountType: getMeta('ajs-account-type') || '',
	relayEnvironment: getRelayEnvironment(),
};

/**
 * WARNING: This plugin always needs intialization at module level.
 * Calling it at runtime will make SSR fail as the `customContext` wouldn't be available.
 */

type ResourcesPlugin = ReturnType<typeof createResourcesPlugin>;

export const resourcesPlugin: ResourcesPlugin = createResourcesPlugin({
	context: customContext,
});
